module.exports = __webpack_public_path__ + "img/smoke10.6896ccfc.png";